import { FieldErrors, FieldValues } from 'react-hook-form';
import { Span } from '@bpba/ui-components';
import { IndexValue } from '../../../types/IndexValue';

type GenericInputErrorProps<T extends FieldValues = FieldValues> = {
  name: string;
  errorCollection?: FieldErrors<T>;
};

export function GenericInputError<T extends IndexValue>(props: GenericInputErrorProps<T>) {
  if (!props || !props.errorCollection) return <></>;

  const fieldErrors = props.errorCollection[props.name];

  if (fieldErrors && fieldErrors.message)
    return (
      <Span color="red" fontSize={'12px'}>
        * {fieldErrors.message}
      </Span>
    );
  return <></>;
}
